import React from 'react';

export default function Titler(Component, title) {
  return (props) => { 
    document.title = title + ' | Orr & Associates';
    return <Component {...props} />;
  }
}